import { useEffect, useRef } from "react";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import Base64ToBlob from "../../../../components/Formatters/Base64ToBlob";

const useDebitosPAT = () => {
  const { request: requestDocumento, data: dataDocumento, isLoading } = useApiClient();
  const toastId = useRef(null);

  const showDebitosPAT = (documentoOs, nomeArquivo, salvar) => {
    let byteArray = documentoOs;

    if (typeof byteArray === "string") {
      byteArray = Base64ToBlob(documentoOs);
    }

    if (nomeArquivo) {
      const tipoArquivo = nomeArquivo.split(".").pop();

      if (tipoArquivo !== "pdf" || salvar) {
        const file = new Blob([byteArray], { type: `application/${tipoArquivo}` });
        saveAs(file, nomeArquivo);
      } else {
        const file = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(file);
        window.open(url, "", "width=800,height=800");
      }
    } else {
      const file = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
  };

  const debitosPAT = (tipoDebito, nuPat) => {
    const params = { NuPat: nuPat };
    toastId.current = toast.info("Gerando arquivo, aguarde...", { autoClose: false });

    if (tipoDebito === "C") {
      requestDocumento(apiRoutes.fiscalizacao.pat.debitosConsolidadoPat, params);
    } else {
      requestDocumento(apiRoutes.fiscalizacao.pat.debitosSinteticoPat, params);
    }
  };

  useEffect(() => {
    if (dataDocumento) {
      if (toastId.current) toast.dismiss(toastId.current);
      showDebitosPAT(dataDocumento);
    }
  }, [dataDocumento]);

  useEffect(() => {
    if (!isLoading && toastId.current) {
      toast.dismiss(toastId.current);
      toastId.current = null;
    }
  }, [isLoading]);

  return { debitosPAT };
};

export default useDebitosPAT;
